// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import {
    FieldDefinitionsBuilderOptionKeyMapping,
    TypographyFieldDefinitionsBuilderOptions,
} from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";

const typographyFieldDictionary: Dictionary<FoundationFieldDefinition | FoundationFieldDefinition[]> = {
    titleStyle: {
        name: "titleStyle",
        displayName: "Title Style",
        editorTemplate: "DropDownField",
        options: [
            { displayName: "Primary Header", value: "headerPrimary" },
            { displayName: "Secondary Header", value: "headerSecondary" },
            { displayName: "Tertiary Header", value: "headerTertiary" },
            { displayName: "H1", value: "h1" },
            { displayName: "H2", value: "h2" },
            { displayName: "H3", value: "h3" },
            { displayName: "H4", value: "h4" },
            { displayName: "H5", value: "h5" },
            { displayName: "H6", value: "h6" },
        ],
        defaultValue: "h2",
        fieldType: "General",
    },
    titleType: {
        name: "titleType",
        displayName: "Title Type",
        editorTemplate: "DropDownField",
        options: [
            { displayName: "H1", value: "h1" },
            { displayName: "H2", value: "h2" },
            { displayName: "H3", value: "h3" },
            { displayName: "H4", value: "h4" },
            { displayName: "H5", value: "h5" },
            { displayName: "H6", value: "h6" },
        ],
        defaultValue: "h2",
        fieldType: "General",
    },
    customColor: [
        {
            fieldType: "General",
            name: "customColor",
            displayName: "Title Color",
            editorTemplate: "ColorPickerField",
            defaultValue: "rgba(0,0,0,0)",
            isVisible: widget => widget.fields.useCustomColor,
        },
        {
            name: "useCustomColor",
            displayName: "Use Custom Color",
            editorTemplate: "CheckboxField",
            defaultValue: false,
            fieldType: "General",
        },
    ],
};

export const buildTypographyFields = (
    options?: TypographyFieldDefinitionsBuilderOptions,
): FoundationFieldDefinition[] => {
    if (!options) {
        return [];
    }

    const typographyFieldDefinitions: FoundationFieldDefinition[] = [];

    for (const key in options) {
        const option = (options as FieldDefinitionsBuilderOptionKeyMapping)[key];

        if (option) {
            const field = typographyFieldDictionary[key];

            if (Array.isArray(field)) {
                typographyFieldDefinitions.push(...(field as FoundationFieldDefinition[]));
            } else {
                typographyFieldDefinitions.push(field as FoundationFieldDefinition);
            }
        }
    }

    return typographyFieldDefinitions;
};
